import { render, staticRenderFns } from "./AdminNextAvailabilitySpecialty.vue?vue&type=template&id=383383ec"
import script from "./AdminNextAvailabilitySpecialty.vue?vue&type=script&lang=js"
export * from "./AdminNextAvailabilitySpecialty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports